import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  constructor(private http: HttpClient) { }

  async imageToBase64(imageUrl: string): Promise<string | null> {
    try {
      const response = await this.http.get(imageUrl, { responseType: 'arraybuffer' }).toPromise();

      // Convert the binary image data to Base64
      const base64Data = btoa(
        new Uint8Array(response).reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
      return base64Data;
    } catch (error) {
      return null;
    }
  }

  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }



  getImageBase64(url: string): Promise<string> {
    return this.http.get(url, { responseType: 'blob' }).toPromise()
      .then(blob => this.blobToBase64(blob));
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }


}